import { formatEmpresa } from "../../utils/functionsFormat";
import TrackerWrapper from "./TrackerWrapper";
import ArrowTracker from "../../assets/img/svg/providers/ArrowTracker.svg";
import ArrowTrackerW from "../../assets/img/svg/providers/ArrowTrackerW.svg";
import ArrowTrackerMovil from "../../assets/img/svg/providers/ArrowTrackerMovil.svg";
import ArrowTrackerMovilW from "../../assets/img/svg/providers/ArrowTrackerMovilW.svg";
import { ReactComponent as PasoCompletoIcon } from "../../assets/img/svg/providers/TrackerPasoCompleto.svg";
import { ReactComponent as PasoIncompletoIcon } from "../../assets/img/svg/providers/TrackerPasoIncompleto.svg";

const StepBulletMobile = ({
  idx,
  isActive,
  isPassed,
  onClick,
  zIndex,
  ml = 0,
}) => {
  const bg = isActive ? ArrowTrackerMovil : ArrowTrackerMovilW;
  const color = isActive ? "white" : isPassed ? "#223D51" : "gray";
  return (
    <div
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "48px",
        height: "27px",
        backgroundImage: `url(${bg})`,
        backgroundSize: "fill",
        backgroundRepeat: "no-repeat",
        color,
        fontWeight: "bold",
        wordWrap: "break-word",
        zIndex,
        cursor: "pointer",
        marginLeft: ml,
      }}
      onClick={onClick}
    >
      <span>{idx}</span>
    </div>
  );
};

const StepItemMobile = ({ label, active, passed, onClick }) => {
  const bg = active ? "#223D51" : passed ? "white" : "#ededed";
  const color = active ? "white" : passed ? "#223D51" : "gray";
  const border = passed ? "1px solid #223D51" : "none";
  const Icon = passed ? PasoCompletoIcon : PasoIncompletoIcon;

  return (
    <div
      className="tracker-movil-container-item"
      style={{ backgroundColor: bg, border }}
      onClick={onClick}
    >
      <Icon width={20} />
      <span style={{ color }}>{label}</span>
    </div>
  );
};

const StepBlockDesktop = ({
  label,
  isActive,
  isPassed,
  zIndex,
  ml = "0px",
  mr = "-90px",
  pt = "20px",
  onClick,
}) => {
  const bg = isActive ? ArrowTracker : ArrowTrackerW;
  const color = isActive ? "white" : isPassed ? "#223D51" : "gray";
  const iconPassed = isPassed;
  const Icon = iconPassed ? PasoCompletoIcon : PasoIncompletoIcon;

  return (
    <div
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "270px",
        height: "100px",
        backgroundImage: `url(${bg})`,
        backgroundSize: "fill",
        backgroundRepeat: "no-repeat",
        color,
        fontWeight: "bold",
        wordWrap: "break-word",
        marginRight: mr,
        zIndex,
        cursor: "pointer",
        paddingTop: pt,
      }}
      onClick={onClick}
    >
      <div style={{ marginLeft: ml, marginRight: "10px" }}>
        <Icon width={20} />
      </div>
      <span>{label}</span>
    </div>
  );
};

const TrackerStepperProjects = ({
  width,
  selectedProject,
  selectedEtapa,
  handleEtapaFilter,
}) => {
  const isActive = (etapa) =>
    selectedProject?.etapa === etapa || selectedEtapa === etapa;
  const isPassed = (etapa) =>
    (selectedProject?.etapa || 0) > etapa || (selectedEtapa || 0) > etapa;

  const mobileHeader = (
    <div className="tracker-movil-container-section">
      <h2>
        Tracker de{" "}
        {selectedProject
          ? formatEmpresa(selectedProject?.nombre)
          : "centros de carga"}
      </h2>
      <div className="tracker-movil-container-body">
        <StepBulletMobile
          idx={1}
          isActive={isActive(2)}
          isPassed={isPassed(2)}
          zIndex={110}
          onClick={() => handleEtapaFilter(2)}
        />
        <StepBulletMobile
          idx={2}
          isActive={isActive(3)}
          isPassed={isPassed(3)}
          zIndex={109}
          ml="-10px"
          onClick={() => handleEtapaFilter(3)}
        />
        <StepBulletMobile
          idx={3}
          isActive={isActive(4)}
          isPassed={isPassed(4)}
          zIndex={108}
          ml="-10px"
          onClick={() => handleEtapaFilter(4)}
        />
        <StepBulletMobile
          idx={4}
          isActive={isActive(5)}
          isPassed={isPassed(5)}
          zIndex={107}
          ml="-10px"
          onClick={() => handleEtapaFilter(5)}
        />
        <StepBulletMobile
          idx={5}
          isActive={isActive(6)}
          isPassed={isPassed(6)}
          zIndex={106}
          ml="-10px"
          onClick={() => handleEtapaFilter(6)}
        />
        <StepBulletMobile
          idx={6}
          isActive={isActive(7)}
          isPassed={isPassed(7)}
          zIndex={105}
          ml="-10px"
          onClick={() => handleEtapaFilter(7)}
        />
        <StepBulletMobile
          idx={7}
          isActive={isActive(8)}
          isPassed={isPassed(8)}
          zIndex={104}
          ml="-10px"
          onClick={() => handleEtapaFilter(8)}
        />
      </div>
    </div>
  );

  const mobileList = (
    <>
      <StepItemMobile
        label="Proyecto creado"
        active={isActive(2)}
        passed={
          isPassed(2) ||
          (selectedProject?.etapa ?? 0) >= 2 ||
          (selectedEtapa ?? 0) >= 2
        }
        onClick={() => handleEtapaFilter(2)}
      />
      <StepItemMobile
        label="Trabajo asignado"
        active={isActive(3)}
        passed={
          isPassed(3) ||
          (selectedProject?.etapa ?? 0) >= 3 ||
          (selectedEtapa ?? 0) >= 3
        }
        onClick={() => handleEtapaFilter(3)}
      />
      <StepItemMobile
        label="Instalador en camino"
        active={isActive(4)}
        passed={
          isPassed(4) ||
          (selectedProject?.etapa ?? 0) >= 4 ||
          (selectedEtapa ?? 0) >= 4
        }
        onClick={() => handleEtapaFilter(4)}
      />
      <StepItemMobile
        label="Instalador en sitio"
        active={isActive(5)}
        passed={
          isPassed(5) ||
          (selectedProject?.etapa ?? 0) >= 5 ||
          (selectedEtapa ?? 0) >= 5
        }
        onClick={() => handleEtapaFilter(5)}
      />
      <StepItemMobile
        label="Trabajo finalizado"
        active={isActive(6)}
        passed={
          isPassed(6) ||
          (selectedProject?.etapa ?? 0) >= 6 ||
          (selectedEtapa ?? 0) >= 6
        }
        onClick={() => handleEtapaFilter(6)}
      />
      <StepItemMobile
        label="Validación de trabajo"
        active={isActive(7)}
        passed={
          isPassed(7) ||
          (selectedProject?.etapa ?? 0) >= 7 ||
          (selectedEtapa ?? 0) >= 7
        }
        onClick={() => handleEtapaFilter(7)}
      />
      <StepItemMobile
        label="Trabajos concluídos"
        active={isActive(8)}
        passed={
          isPassed(8) ||
          (selectedProject?.etapa ?? 0) >= 8 ||
          (selectedEtapa ?? 0) >= 8
        }
        onClick={() => handleEtapaFilter(8)}
      />
    </>
  );

  const desktop = (
    <>
      <h2>
        Tracker de{" "}
        {selectedProject
          ? formatEmpresa(selectedProject?.nombre)
          : "centros de carga"}
      </h2>

      <TrackerWrapper baseWidth={1300}>
        <div
          className="tracker-container"
          style={{
            display: "flex",
            fontSize: "14px",
            textAlign: "left",
            flexWrap: "wrap",
            margin: "-18px 0 20px -26px",
            backgroundColor: "rgba(255, 255, 255, 0)",
          }}
        >
          <StepBlockDesktop
            label="Proyecto creado"
            isActive={isActive(2)}
            isPassed={
              isPassed(2) ||
              (selectedProject?.etapa ?? 0) >= 2 ||
              (selectedEtapa ?? 0) >= 2
            }
            zIndex={110}
            ml="-40px"
            onClick={() => handleEtapaFilter(2)}
          />
          <StepBlockDesktop
            label="Trabajo asignado"
            isActive={isActive(3)}
            isPassed={
              isPassed(3) ||
              (selectedProject?.etapa ?? 0) >= 3 ||
              (selectedEtapa ?? 0) >= 3
            }
            zIndex={19}
            ml="30px"
            onClick={() => handleEtapaFilter(3)}
          />
          <StepBlockDesktop
            label={
              <>
                Instalador en
                <br />
                camino
              </>
            }
            isActive={isActive(4)}
            isPassed={
              isPassed(4) ||
              (selectedProject?.etapa ?? 0) >= 4 ||
              (selectedEtapa ?? 0) >= 4
            }
            zIndex={18}
            ml="10px"
            onClick={() => handleEtapaFilter(4)}
          />
          <StepBlockDesktop
            label="Instalador en sitio"
            isActive={isActive(5)}
            isPassed={
              isPassed(5) ||
              (selectedProject?.etapa ?? 0) >= 5 ||
              (selectedEtapa ?? 0) >= 5
            }
            zIndex={17}
            ml="40px"
            onClick={() => handleEtapaFilter(5)}
          />
          <StepBlockDesktop
            label="Trabajo finalizado"
            isActive={isActive(6)}
            isPassed={
              isPassed(6) ||
              (selectedProject?.etapa ?? 0) >= 6 ||
              (selectedEtapa ?? 0) >= 6
            }
            zIndex={16}
            ml="40px"
            onClick={() => handleEtapaFilter(6)}
          />
          <StepBlockDesktop
            label={
              <>
                Validación de <br />
                trabajo
              </>
            }
            isActive={isActive(7)}
            isPassed={
              isPassed(7) ||
              (selectedProject?.etapa ?? 0) >= 7 ||
              (selectedEtapa ?? 0) >= 7
            }
            zIndex={15}
            ml="10px"
            onClick={() => handleEtapaFilter(7)}
          />
          <StepBlockDesktop
            label={
              <>
                Trabajos <br />
                concluídos
              </>
            }
            isActive={isActive(8)}
            isPassed={
              isPassed(8) ||
              (selectedProject?.etapa ?? 0) >= 8 ||
              (selectedEtapa ?? 0) >= 8
            }
            zIndex={14}
            ml="10px"
            onClick={() => handleEtapaFilter(8)}
          />
        </div>
      </TrackerWrapper>
    </>
  );

  return width <= 900 ? (
    <div className="tracker-movil-container">
      {mobileHeader}
      {mobileList}
    </div>
  ) : (
    desktop
  );
};

export default TrackerStepperProjects;
